module.exports = __webpack_public_path__ + "static/img/videoBgimg.36bb9f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/videoBgimg.png
// module id = +bEL
// module chunks = 1